<div
  class="card border-info mb-3"
  *ngFor="let activity of activity.previousActivities"
  [ngClass]="{ 'card-content': templateForPermitForm }"
>
  @if(templateForPermitForm){
    <!-- <div class="card-header" [id]="'heading' + activity.id">
      <h5 class="mb-0">
        <wm-common-button
          [data]="{
            text: activity.model.screenName,
            variant: 'basic'}">
        </wm-common-button>
      </h5>
    </div> -->
    <mat-card
      [id]="activity.id"
      class="activity-card"
    >
      <mat-card-header class="card-header">
        <!-- <mat-card-title> -->
          <div class="title">
            <wm-common-text
              [data]="{
                text: activity.model.screenName,
                textTransform: 'uppercase'
              }">
            </wm-common-text>
          </div>
        <!-- </mat-card-title> -->
      </mat-card-header>

      <mat-card-content>
        <wm-activity-view
          [activity]="activity"
          [isReadOnly]="true"
          [form]="form"
          [isPreview]="false"
        ></wm-activity-view>
      </mat-card-content>
    </mat-card>

  }@else{
    <div class="card-header" [id]="'heading' + activity.id">
      <h5 class="mb-0">
        <button
          class="btn btn-link"
          type="button"
          data-toggle="collapse"
          [attr.data-target]="'#' + activity.id"
          aria-expanded="true"
          [attr.aria-controls]="'#' + activity.id"
        >
          {{ activity.model.screenName }}
        </button>
      </h5>
    </div>
    <div
      [id]="activity.id"
      class="collapse show"
      [attr.aria-labelledby]="'heading' + activity.id"
    >
      <div class="card-body">
        <wm-activity-view
          [activity]="activity"
          [isReadOnly]="true"
          [form]="form"
          [isPreview]="false"
        ></wm-activity-view>
      </div>
    </div>
  }
</div>
